export interface RadarInput {
  label: string;
  pct: number; // 0-100
}

export function radarPointCoords(
  count: number,
  index: number,
  value: number,
  cx: number,
  cy: number,
  maxRadius: number
): { x: number; y: number } {
  const angle = (Math.PI * 2 * index) / count - Math.PI / 2;
  const r = (value / 100) * maxRadius;
  return { x: cx + r * Math.cos(angle), y: cy + r * Math.sin(angle) };
}

export function buildRadarPolygonPoints(
  values: RadarInput[],
  cx: number,
  cy: number,
  maxRadius: number
): string {
  return values
    .map((v, i) => {
      const { x, y } = radarPointCoords(values.length, i, v.pct, cx, cy, maxRadius);
      return `${x.toFixed(2)},${y.toFixed(2)}`;
    })
    .join(" ");
}

export function buildAxisEndpoints(
  count: number,
  cx: number,
  cy: number,
  maxRadius: number
): Array<{ x: number; y: number }> {
  return Array.from({ length: count }, (_, i) =>
    radarPointCoords(count, i, 100, cx, cy, maxRadius)
  );
}
